<section class="meander_certificate_body_wrap container mt-30px">
  <div class="certificate_body_background">
    <div class="badge_on_top">
      <img src="assets/badge_for_cert.png" alt="badge_icon">
    </div>
    <div class="certificate_top_head">
      <h1>CERTIFICATE</h1>
      <h6>OF PARTICIPATION</h6>
    </div>
    <div class="certify_to_name">
      <p>THIS IS TO CERTIFY THAT</p>
      <h1>Shubham Kumar</h1>
    </div>
    <div class="event_date_place">
      <p>
       Has successfully
        participated in the event
        <span class="text_bold_600">Event Name</span> Organizes on
        <span class="text_bold_600">16/Sep/2023</span> by Meander.
      </p>
    </div>
    <div class="cert_is_awarded">
      <p>
        This certificate is awarded in recognition of your active participation
        and valuable contribution to the success of the event. Your enthusiasm
        and dedication to learning and personal growth have been truly
        commendable.
      </p>
    </div>
    <div class="certificate_footer">
      <div class="row">
        <div class="col-6">
          <div class="footer_left_logo">
            <img src="assets/logo-meander-black.png" alt="meander_logo">
          </div>
        </div>
        <div class="col-6">
          <div class="footer_signature_right">
            <div class="text-align-center">
            <h5>Instructor's/Event</h5>
            <h5>Oraganizer's Signature</h5></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section>
  <div class="container pm-certificate-container">
    <div class="outer-border"></div>
    <div class="inner-border"></div>

    <div class="pm-certificate-border">
      <div class="pm-certificate-header">
        <div class="pm-certificate-title cursive text-center">
          <img src="assets/logo-meander-black.png" alt="main_logo" />
        </div>
      </div>

      <div class="row pm-certificate-body">
        <div class="pm-certificate-block">
          <div class="col-xs-12 text-align-right underline pb-3">
            <span class="pm-name-text bold">Certificate of Participation</span>
          </div>

          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-2"></div>
              <div class="pm-earned col-xs-8 text-center">
                <span class="pm-earned-text padding-0 block"
                  >This is to certify that <span class="text_bold_600">Ankush Pathania</span> Has
                  successfully participated in the event <span class="text_bold_600">Event Name</span> Organizes on <span class="text_bold_600">16/Sep/2023</span>
                  by <i> Meander</i> Training.
                </span>
              </div>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-2"></div>
              <div class="pm-course-title col-xs-8 text-center">
                <span class="pm-earned-text block"
                  >This certificate is awarded in recognition of your active
                  participation and valuable contribution to the success of the
                  event. Your enthusiasm and dedication to learning and personal
                  growth have been truly commendable.</span
                >
              </div>
            </div>
          </div>
          <div class="col-xs-12 date_location pb-2 underline">
            <div class="row">
              <div class="col-6 text-center"></div>
              <div class="col-6 text-center"></div>
            </div>
          </div>
          <div class="certificate_footer underline">
            <div class="row">
              <div class="col-6 text-center">
                <p>[Title, if applicable]</p>

                <p>Location: [Location of the Event]</p>
              </div>
              <div class="col-6 text-center">
                <p>[Date of Certificate Issuance]</p>

                <p>[Instructor's/Event Organizer's Name]</p>
               
              </div>
            </div>
          </div>
   
          <div class="meander_cert_quality-logo">

          </div>
          <div class="meander_cert_footer">
            <h6>[Instructor's/Event Organizer's Signature]</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
